import {
  TEMPLATE_REGISTRY,
  type TemplateDefinition,
} from "@/components/AIComponents/ExportablesModal/templates/registry";
import type { GraphicOrganizersActivities } from "@/types/models";
import type {
  ExportablesDataTypes,
  ExportablesGenerationResponse,
} from "@/types/models/Exportables.interface";

const buildTemplateList = ({
  isStudent = false,
  isStudentPreviewOn = false,
  fetchedGraphicOrganizerResponseData,
  exportablesMetadata,
}: {
  isStudent?: boolean;
  isStudentPreviewOn?: boolean;
  fetchedGraphicOrganizerResponseData?: GraphicOrganizersActivities | undefined;
  exportablesMetadata?: ExportablesGenerationResponse | undefined;
}): TemplateDefinition[] => {
  const allTemplates = Object.values(
    TEMPLATE_REGISTRY,
  ) as TemplateDefinition<ExportablesDataTypes>[];

  if (isStudent || isStudentPreviewOn) {
    const fetchedIdentifiers =
      fetchedGraphicOrganizerResponseData?.graphic_organizers?.map((template) =>
        template.graphic_organizer_type.replace("graphic_organizer_", ""),
      ) || [];

    if (fetchedIdentifiers.length > 0) {
      return allTemplates.filter((template) =>
        fetchedIdentifiers.includes(template.seti_identifier),
      );
    }

    return [];
  }

  if (exportablesMetadata) {
    return allTemplates.filter(
      (template) => !!exportablesMetadata[template.seti_identifier],
    );
  }

  return [];
};

export default buildTemplateList;
